import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import api from "../../api";
import IranFlag from "../../assets/images/iran.webp";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/cover.css';
import '../../css/styles.css';
import {toast, ToastContainer} from "react-toastify";
import LoadingSpinner from "../Loading";
import {e2p, p2e} from "../../utils/utils";

function Reception() {
    const [car, setCar] = useState(null);
    const [amountOfFuel, setAmountOfFuel] = useState(null);
    const [kilometerage, setKilometerage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const {carId} = useParams();
    const {requestId} = useParams();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!parseInt(p2e(kilometerage))) {
            toast.error('لطفا کیلومتر را به درستی وارد کنید')
            return;
        }
        
        const requestBody = {
            'amount_of_fuel': amountOfFuel,
            'kilometerage': p2e(kilometerage)
        }
        try {
            const response = await api.post(`/repair-request/${requestId}`, requestBody);
            window.location.href = `/car/${carId}/smoothing/${requestId}`
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }

    useEffect(() => {
        setIsLoading(true);
        api.get(`/car/${carId}`)
            .then((res) => {
                setCar(res.data.data);
            })
            .catch((err) => {
                toast.error('مشکلی پیش آمده. لطفا دوباره تلاش کنید!')
            })
            .finally(() => {
                setIsLoading(false);
            })
    }, []);

    return (
        <div>
            {isLoading ? <LoadingSpinner/> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        
                        <div className="row justify-content-center g-0">
                            <div className="row w-auto pelak g-0 mb-3">
                                <div className="col">
                                    <div className="row my-auto">
                                        <div className="col border-start border-end-0">
                                            <p className="text-center fw-bold iranNo">ایران</p>
                                            <div>
                                                <p className="border-0 text-center">{car?.plate.slice(7, 9)}</p>
                                            </div>
                                        </div>
                                        <div className="col my-auto">
                                            <p className="border-0 text-center">{car?.plate.slice(3, 6)}</p>
                                        </div>
                                        <div className="col my-auto">
                                            <p className="border-0 text-center">{car?.plate.slice(2, 3)}</p>
                                        </div>
                                        <div className="col my-auto">
                                            <p className="border-0 text-center">{car?.plate.slice(0, 2)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-auto leftSide">
                                    <div className="flag">
                                        <img src={IranFlag} alt="iran's flag"/>
                                    </div>
                                    <div className="iranText text-center">
                                        <p>I.R.</p>
                                        <p>IRAN</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                <div className="card rounded-4 border-2 border-dark mb-2">
                                    <h5 className="card-header text-center bg-dark text-white fw-bold">ثبت کیلومتر و
                                        میزان سوخت</h5>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <label htmlFor="kilometerage" className="form-label">کیلومتر</label>
                                                <input
                                                    required
                                                    type="text"
                                                    className="form-control shadow"
                                                    id="kilometerage"
                                                    name="kilometerage"
                                                    value={e2p(kilometerage)}
                                                    onChange={(e) => {
                                                        setKilometerage(e.target.value);
                                                    }}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="f-type" className="form-label">میزان سوخت</label>
                                                <select
                                                    required
                                                    id="desc"
                                                    className="form-select shadow"
                                                    name="description"
                                                    value={amountOfFuel}
                                                    onChange={(e) => {
                                                        setAmountOfFuel(e.target.value);
                                                    }}
                                                >
                                                    <option>--انتخاب کنید--</option>
                                                    <option value="پر">پر</option>
                                                    <option value="سه چهارم">سه چهارم</option>
                                                    <option value="نصف">نصف</option>
                                                    <option value="یک چهارم">یک چهارم</option>
                                                    <option value="خالی">خالی</option>
                                                </select>
                                            </div>
                                            <div className='d-grid gap-2'>
                                                <input type="submit" className="btn btn-warning" name="submit"
                                                       value="ثبت"/>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Reception
